import gql from 'graphql-tag';

export default gql`
  mutation archiveAsset($assetId: String!) {
    archiveAsset(assetId: $assetId) {
      assetId
    }
  }
`;
